import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AddIcon extends BaseIcon {
  getChildren = () => [<path fill={ this.getColor() } d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'/>]
  getViewBox = () => '4 4 16 16'
}
